import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
import { type StoreChatItem } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { lastAssistantHasAskQuestionAction } from './lastAssistantHasAskQuestionAction';
import { lastAssistantHasConfluencePageAction } from './lastAssistantHasConfluencePageAction';
import { lastAssistantResponseIsSubstantive } from './lastAssistantResponseIsSubstantive';

export function shouldAppendCreatePageFollowUp(
	messages: StoreChatItem[],
	productKey: string | undefined,
	isSmartCreationModalOpen: boolean = false,
): boolean {
	if (
		productKey !== 'confluence' ||
		!expValEquals('confluence_fe_create_page_suggestion', 'isEnabled', true)
	) {
		return false;
	}
	// Already in a content-creation surface — the suggestion would be redundant.
	if (isSmartCreationModalOpen) {
		return false;
	}
	// An `ask_question` response is an interim clarifying step, not a final
	// answer, so there is nothing to "create a page from" yet — don't synthesize
	// the create-page follow-up for it.
	if (
		lastAssistantHasAskQuestionAction(messages) &&
		expValEquals('cc-disambiguation-in-cwr', 'isEnabled', true)
	) {
		return false;
	}
	if (!lastAssistantResponseIsSubstantive(messages)) {
		return false;
	}
	return !lastAssistantHasConfluencePageAction(messages);
}
